<template>
  <v-flex
    column
    role="region"
    aria-label="Shop content"
  >
    <!-- Parallax Banner with Semantic Header Info -->
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/shoplayout-cover.png"
      height="350"
      aria-label="Shop banner"
      role="img"
    >
      <v-layout
        column
        align-center
        justify-center
        class="text-center"
      >
        <h1 class="white--text">
          {{ $t("components.shop.title") }}
        </h1>
        <h2 class="white--text">
          {{ $t("components.shop.subtitle") }}
        </h2>
      </v-layout>
    </v-parallax>

    <!-- Main Shop Card Container -->
    <v-card
      color="secondary"
      role="region"
      aria-label="Shop Interface"
    >
      <v-layout
        column
        pb-2
        class="primary"
      >
        <v-flex
          xs12
          sm12
          md8
          lg8
          justify-center
        >
          <v-card
            class="profile-section-card--flex-toolbar"
            flat
            role="group"
            aria-label="Shop sections"
          >
            <v-card flat>
              <v-container
                fluid
                grid-list-md
              >
                <!-- Navigation Tabs for Categories -->
                <v-tabs
                  v-model="active_tab"
                  fixed-tabs
                  color="accent"
                  show-arrows
                  centered
                  next-icon="fad fa-chevron-right"
                  prev-icon="fad fa-chevron-left"
                  slider-color="accent"
                  role="tablist"
                  aria-label="Shop category tabs"
                >
                  <v-tabs-slider />
                  <v-tab
                    v-for="tab in tabs"
                    :key="tab.id"
                    :to="tab.route"
                    exact
                    role="tab"
                    :aria-selected="$route.path === tab.route"
                    :aria-label="$t(`shop.tabs.${tab.category}`) || tab.category"
                    :tabindex="$route.path === tab.route ? 0 : -1"
                    @click="setCategory(tab.category)"
                  >
                    <v-icon
                      :aria-hidden="true"
                      class="mr-1"
                    >
                      {{ tab.icon }}
                    </v-icon>
                    <span class="sr-only">
                      {{ $t(`shop.tabs.${tab.category}`) || tab.category }}
                    </span>
                  </v-tab>
                </v-tabs>

                <!-- Character Selector -->
                <select-user-char
                  v-if="isCompletedOAuth"
                  @selectedChar="selectedChar"
                />

                <!-- Dynamic Category View -->
                <router-view
                  :char-id="charId"
                  :category="category"
                  role="region"
                  aria-live="polite"
                  aria-label="Shop item section"
                />
              </v-container>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import config from "@/constants/config";
import ShopTabs from "@/constants/shop.tabs";
import SelectUserChar from "@/components/Views/SelectUserCharacter";

export default {
    name: "ShopLayout",
    components: {
        SelectUserChar
    },
    data() {
        return {
            active_tab: 0,
            tabs: ShopTabs.list,
            category: "",
            charId: 0
        }
    },
    computed: {
        // Check if is logged
        isCompletedOAuth() {
            return this.$store.getters.isLogged && this.$store.getters.username;
        }
    },
    beforeMount() {
        const isDefined = this.$router.currentRoute.meta.props.category != "undefined";

        this.category =
            isDefined
            ? this.$router.currentRoute.meta.props.category
            : config.default.shopCategory;
    },
    methods: {
        selectedChar(charId) {
            this.charId = charId;
        },
        setCategory(category) {
            this.category = category;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~/_variables.scss';

    .shop-popular,
    .shop-pet,
    .shop-limited,
    .shop-char,
    .shop {

        &-pack {

            &-badges {
                min-height: 8rem;
            }

            &-selected {
                box-shadow: 0 1px 0px -2px $accent,
                    0 1px 1px 0 $accent,
                    0 0px 0px 0 $accent !important;
            }
        }
    }

    .sr-only {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
    }
</style>
